import type { WavespeedModelConfig } from '../../types';
import { nanoBananaConfigs } from './nano-banana';
import { imagenConfigs } from './imagen';

export const googleConfigs: Record<string, WavespeedModelConfig> = {
    ...nanoBananaConfigs,
    ...imagenConfigs,
};